function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { ButtonGroup } from '../button-group';
import css from './content.scss';
function getText({
  blankSamplePrice,
  minQuantityError,
  minQuant,
  maxQuant,
  quantIncrement,
  maxQuantityError,
  minQuantityPerProductError,
  minQuantityPerRelatedProductError,
  quantityIncrementError,
  uploadWarningPopupContent,
  embellishmentError,
  isLogoUploadedAndPriceSet,
  quantityMoreThanSupplierHasError,
  superSpeedColorLimitationError,
  superSpeedColorLimit
}) {
  if (minQuantityError) {
    return /*#__PURE__*/React.createElement("div", {
      className: css.textClassName
    }, /*#__PURE__*/React.createElement("p", null, `Please make sure you have selected at least ${minQuant}.`), blankSamplePrice ? /*#__PURE__*/React.createElement("p", null, "If you want to order a sample before placing your full order, click on the Buy Sample button above!") : null);
  }
  if (maxQuantityError) {
    return /*#__PURE__*/React.createElement("div", {
      className: css.textClassName
    }, /*#__PURE__*/React.createElement("p", null, `Please make sure you have selected ${maxQuant} or less.`));
  }
  if (quantityMoreThanSupplierHasError) {
    return /*#__PURE__*/React.createElement("div", {
      className: css.textClassName
    }, /*#__PURE__*/React.createElement("p", null, quantityMoreThanSupplierHasError));
  }
  if (quantityIncrementError) {
    return /*#__PURE__*/React.createElement("div", {
      className: css.textClassName
    }, /*#__PURE__*/React.createElement("p", null, "Please make sure you have selected an amount that is an increment of", ' ', quantIncrement, ", for example, ", minQuant, ", ", minQuant + quantIncrement, ",", ' ', minQuant + quantIncrement * 2, ", etc."));
  }
  if (minQuantityPerProductError || minQuantityPerRelatedProductError) {
    return /*#__PURE__*/React.createElement("div", {
      className: css.textClassName
    }, /*#__PURE__*/React.createElement("p", null, `Please make sure you have selected at least ${1}.`), blankSamplePrice && /*#__PURE__*/React.createElement("p", null, "If you want to order a sample before placing your full order, click on the Buy Sample button above!"));
  }
  if (embellishmentError) {
    return /*#__PURE__*/React.createElement("div", {
      className: css.textClassName
    }, /*#__PURE__*/React.createElement("p", null, "In order to proceed, you first need to select your decoration method and how you want your design to be embellished."));
  }
  if (!isLogoUploadedAndPriceSet) {
    return /*#__PURE__*/React.createElement("div", {
      className: css.textClassName
    }, /*#__PURE__*/React.createElement("p", null, uploadWarningPopupContent));
  }
  if (superSpeedColorLimitationError) {
    return /*#__PURE__*/React.createElement("div", {
      className: css.textClassName
    }, /*#__PURE__*/React.createElement("p", null, "Unfortunately, your logo has more colors than we can support if you switch to Super Speed. Please update your logo to one that has only ", superSpeedColorLimit, ' ', "color(s) so we can meet the Super Speed production timeline."));
  }
}
export const Content = props => {
  const {
      onClose
    } = props,
    restProps = _objectWithoutProperties(props, ["onClose"]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, getText(restProps), /*#__PURE__*/React.createElement(ButtonGroup, {
    onClose: onClose
  }));
};